import { useContext } from "react";
import { OrdersContext } from "../../context/OrdersContext";
import { Col,DatePicker } from "antd";
import { TableToManage } from "./components/TableToManage";
import { TableDeliveryConfirmation } from "./components/TableDeliveryConfirmation";

const { RangePicker } = DatePicker;
const dateFormat = "DD-MM-YYYY";

export const BoardCustomerService = () => {
    const {
        filteredOrdersByEnd,
        dateFilter,
        isLoadingSales,
        isLoadingDateFilteredData,
        setDateFilter,
        refetch
      } = useContext(OrdersContext);

    const isLoading = isLoadingSales || isLoadingDateFilteredData;

    if(isLoading){
        return (
            <div className="mt-10 ml-5">
              Cargando Ordenes...
            </div>
        );
    }else{
        return(
            <div className="grid-rows-custom grid-cols-custom gap-x-0 gap-y-0 m-5 w-full xl:w-11/12">
                <div>
                    <div
                    className="flex justify-end"
                    >
                    <div className="pb-4">
                        <RangePicker
                        value={dateFilter}
                        onChange={(dates) => setDateFilter(dates)}
                        format={dateFormat}
                        />
                    </div>
                    </div>
            </div>
                <Col className="my-4" xs={24} sm={24} md={24} lg={24} xl={24}>
                    <TableToManage data={filteredOrdersByEnd} refetch={refetch}/>
                </Col>
                <Col className="my-4" xs={24} sm={24} md={24} lg={24} xl={24}>
                    <TableDeliveryConfirmation data={filteredOrdersByEnd} refetch={refetch}/>
                </Col>
            </div>
        );
    }
}